export const ArrayRender = (array, field) => {
  if (!array || !Array.isArray(array)) {
    return null;
  }

  return array.map(
    (el, index) => `${index !== 0 ? ', ' : ''}${field ? el[field] : el}`,
  );
};
